export default __webpack_public_path__ + "static/media/bannerOne.f5a6b1a8.png";